import React from 'react';
import {
  Container,
  Box,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';

import { Plan } from '@screens/home/benefits/Plan';

interface PlanModel {
  title: string;
  details: string[];
}

const plans: PlanModel[] = [
  {
    title: 'Amplia',
    details: [
      'Daños materiales',
      'Robo total',
      'Gastos médicos',
      'Defensa legal',
      'Responsabilidad civil',
      'Asistencia en viajes',
    ],
  },
  {
    title: 'Intermedia',
    details: [
      'Robo total',
      'Gastos médicos',
      'Defensa Legal',
      'Responsabilidad civil',
      'Asistencia en viajes',
    ],
  },
  {
    title: 'Básica',
    details: [
      'Responsabilidad civil',
      'Gastos médicos',
      'Defensa Legal',
      'Asistencia en viajes',
    ],
  },
];

export const Plans: React.FC = () => {
  const { breakpoints } = useTheme();
  const isTablet = useMediaQuery(breakpoints.down('md'));
  return (
    <Container maxWidth={'lg'}>
      <Box sx={{ flexGrow: 1 }} style={{ marginTop: 50, marginBottom: 50 }}>
        <Typography
          variant={'h2'}
          fontWeight={'bold'}
          style={{ marginBottom: 50 }}
          textAlign={isTablet ? 'start' : 'center'}
        >
          {'Coberturas a prueba de todo'}
        </Typography>
        <Grid container spacing={4} alignItems={'stretch'}>
          {plans.map((plan, i) => (
            <Plan key={i} plan={plan} />
          ))}
        </Grid>
      </Box>
    </Container>
  );
};
